import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultSeasonPoolExportFieldNames } from "~pages/SeasonPools/SeasonPoolListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasonPools = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/pools/export`, {
        method: "POST",
        body: {
          fieldNames: fieldNames || defaultSeasonPoolExportFieldNames,
        },
      }),
  });
};
